import * as Moment from 'moment'
import { Badge } from 'reactstrap'
import { accentUtils } from '../../services/HelperService';

export const InstallTimeBadge = props => {

    const hrs = Moment.utc(Moment.duration(props.EstInstallTime, "minutes").asMilliseconds()).format("H");
    const mins = Moment.utc(Moment.duration(props.EstInstallTime, "minutes").asMilliseconds()).format("mm");

    let instTime;
    if (hrs === "0" && props.hideHours) {
        instTime = `${mins} mins`;
    } else {
        instTime = `${hrs} hours and ${mins} mins`;
    }

    if (accentUtils.isEmpty(props.EstInstallTime) && props.hideEmpty) return null;

    return <Badge>{instTime}</Badge>;

};
